import Reveal from "./Reveal";

export default function SectionTitle({ overline, title, description, align = "center", testid }) {
  const alignCls = align === "left" ? "text-left items-start" : "text-center items-center mx-auto";
  return (
    <Reveal
      className={`flex flex-col gap-3 ${alignCls} max-w-3xl`}
      data-testid={testid}
    >
      {overline ? (
        <span className="inline-flex items-center gap-2 rounded-full border border-yellow-400/30 bg-yellow-400/5 px-3 py-1 text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase text-yellow-400">
          <span className="w-1.5 h-1.5 rounded-full bg-yellow-400" />
          {overline}
        </span>
      ) : null}
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
        {title}
      </h2>
      {description ? (
        <p className="text-sm sm:text-base text-neutral-400 leading-relaxed max-w-2xl">
          {description}
        </p>
      ) : null}
    </Reveal>
  );
}
